import { memo } from "react";

function LoadingState({
	label = "Loading...",
	description = "Please wait while we load the latest content.",
	minHeight = 260,
}) {
	return (
		<div
			className="flex w-full flex-col items-center justify-center px-4 py-12 text-center"
			style={{ minHeight }}
			role="status"
			aria-live="polite"
			aria-busy="true"
		>
			<div
				className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-[#1f4c94]"
				aria-hidden="true"
			/>

			<p className="mt-4 font-poppins text-base font-semibold text-gray-800">
				{label}
			</p>

			{description ? (
				<p className="mt-1 max-w-md text-sm text-gray-500">
					{description}
				</p>
			) : null}
		</div>
	);
}

export default memo(LoadingState);
